exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\n  background: rgba(0,0,0,0.7);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.overlay.center {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n.overlay.center .overlay-content {\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n}\n\n", ""]);

// exports
